import { type___locale___translations___collection } from "../../types/types.locale";

//	E X P O R T   L O C A L E

export const locale___SbSignPage: type___locale___translations___collection = {
	'section___login': {
		de_de: 'Login',
		en_us: 'Login',
		es_es: 'Acceso',
		fr_fr: 'Se connecter',
		it_it: 'Login',
	},
	'toastSuccess___signSuccess___login': {
		de_de: 'Sie haben sich erfolgreich angemeldet',
		en_us: 'You have logged in successfully',
		es_es: 'Has iniciado sesión correctamente',
		fr_fr: 'Vous vous êtes connecté avec succès',
		it_it: 'Ti sei loggato con successo',
	},
	'toastError___login___username': {
		de_de: 'Benutzername nicht erkannt',
		en_us: 'Username not recognized',
		es_es: 'Nombre de usuario no reconocido',
		fr_fr: 'Nom d\'utilisateur non reconnu',
		it_it: 'Username non riconosciuto',
	},
	'toastError___login___password': {
		de_de: 'Falsches Passwort',
		en_us: 'Wrong Password',
		es_es: 'Contraseña incorrecta',
		fr_fr: 'Mauvais mot de passe',
		it_it: 'Password sbagliata',
	},
	'toastError___login___generic': {
		de_de: 'Allgemeiner Fehler beim Anmelden. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support',
		en_us: 'Generic error during login. If the problem persists, contact support.',
		es_es: 'Error genérico al iniciar sesión, si el problema persiste contacte con soporte',
		fr_fr: 'Erreur générique lors de la connexion, si le problème persiste, contactez le support',
		it_it: 'Errore generico durante, il login, se il problema persiste contatta l\'assistenza',
	},
	'login___form___password_forgot': {
		de_de: 'Haben Sie Ihr Passwort vergessen?',
		en_us: 'Forgot your password?',
		es_es: '¿Olvidaste tu contraseña?',
		fr_fr: 'Avez-vous oublié votre mot de passe?',
		it_it: 'Hai dimenticato la password?'
	},
	'login___form___eula': {
		de_de: 'Mit der Anmeldung auf der Plattform akzeptiere ich ausdrücklich und uneingeschränkt alle',
		en_us: 'By logging into the platform, I explicitly and fully accept all',
		es_es: 'Al iniciar sesión en la plataforma acepto explícita y plenamente a todos.',
		fr_fr: 'En me connectant à la plateforme, j\'accepte explicitement et pleinement tout le monde',
		it_it: 'Effettuando il login nella piattaforma accetto esplicitamente ed integralmente tutti'
	},
	'login___form___eula_url': {
		de_de: 'die auf dieser Seite einsehbaren Allgemeinen Geschäftsbedingungen',
		en_us: 'the Terms and Conditions viewable on this page',
		es_es: 'los Términos y condiciones visibles en esta página',
		fr_fr: 'les Conditions Générales consultables sur cette page',
		it_it: 'i Termini e le Condizioni visionabili in questa pagina'
	},
	'login___form___button___disabled': {
		de_de: 'Benutzername und Passwort fehlen',
		en_us: 'Username and password are missing',
		es_es: 'Faltan nombre de usuario y contraseña',
		fr_fr: 'Le nom d\'utilisateur et le mot de passe sont manquants',
		it_it: 'Mancano username e password'
	},
	'login___form___button___enabled': {
		de_de: 'Anmeldung',
		en_us: 'Login',
		es_es: 'Acceso',
		fr_fr: 'Se connecter',
		it_it: 'Login'
	},
	'login___form___button___missing_eula': {
		de_de: 'Akzeptieren Sie die Allgemeinen Geschäftsbedingungen',
		en_us: 'accept the terms and conditions',
		es_es: 'aceptar los términos y condiciones',
		fr_fr: 'accepter les termes et conditions',
		it_it: 'accetta i termini e le condizioni'
	},
};